import AgencyRole from "./AgencyRole.js";

/**
 * `ConsultantRole` describes permissions of a consultant over other users.
 */
export default class ConsultantRole extends AgencyRole {
	canDeleteUser(user) {
		return user
			.getRoles()
			.every((role) => role.canBeDeletedByConsultant(this));
	}

	canAttachOrDetachCompanyId(user, companyId) {
		return user
			.getRoles()
			.some((role) =>
				role.canCompanyIdBeAttachedOrDetachedByConsultant(
					this,
					companyId,
				),
			);
	}

	canEditUserInfo(user) {
		return user
			.getRoles()
			.some((role) => role.canUserInfoBeEditedByConsultant(this));
	}

	canViewAccountingDocuments(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}

	canChangeCompanyPackage(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}

	//
	// canUpgradeSubscriptionPlan
	//

	canUpgradeSubscriptionPlanForCompany(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}

	canExtractDataFromCompany(company) {
		return this.canAdministrateCompanyId(company.getLegacyId());
	}

	canShareChartOfAccounts() {
		return true;
	}
}
